// src/components/RegisterPage.jsx
import LoginPage from './LoginPage';
export default LoginPage;